module.exports = __webpack_public_path__ + "static/media/icon-search.716f47fc.svg";